<template>
  <div class="bg-white p-4 px-4 rounded-lg float-item shadow-md">
    <div class="w-full flex items-center pb-4">
      <span class="turn-off"><ArrowDownGP /></span>
      <div class="w-full text-black pl-2">
        <b class="w-full block text-left">{{ incoming }}</b>

        <span class="w-full block text-left">Incoming</span>
      </div>
    </div>
    <div class="w-full flex items-center">
      <span class="turn-up"><ArrowDownGP color="#FCC210" /></span>
      <div class="w-full text-black pl-2">
        <b class="w-full block text-left">{{ outgoing }}</b>

        <span class="w-full block text-left">Outgoing</span>
      </div>
    </div>
  </div>
</template>

<script>
import ArrowDownGP from "@/assets/images/ondemand/ArrowDownGP";

export default {
  props: ["incoming", "outgoing"],
  components: { ArrowDownGP },
};
</script>

<style lang="scss" scoped>
.turn-up {
  transform: rotateZ(180deg);
}
.turn-off {
  transform: rotateZ(0deg);
}
.float-item {
  @apply absolute;
  top: calc(100% + 7px);
  overflow: hidden;
  animation: slide-roll 200ms linear 1;
}
@keyframes slide-roll {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
</style>
